module.exports = __webpack_public_path__ + "img/tenE.a7993b61.jpg";